import { Link, useLocation } from 'react-router-dom';
import { Briefcase, User } from 'lucide-react';

/**
 * Pill-style toggle shown at the top of the login pages so visitors
 * can choose between the Medewerker (employee) and Klant (client) portals.
 *
 * Active option is highlighted; clicking the other navigates to its login.
 */
const LoginRoleToggle = () => {
  const location = useLocation();
  const isClient = location.pathname.startsWith('/client');

  return (
    <div
      className="inline-flex items-center bg-white/10 backdrop-blur border border-white/20 rounded-full p-1 mx-auto"
      data-testid="login-role-toggle"
    >
      <Link
        to="/login"
        data-testid="role-medewerker-btn"
        className={`flex items-center gap-2 px-5 py-2 rounded-full text-sm font-semibold transition ${
          !isClient ? 'bg-[#3da5a5] text-white shadow' : 'text-white/70 hover:text-white'
        }`}
      >
        <Briefcase className="w-4 h-4" />
        Medewerker
      </Link>
      <Link
        to="/client"
        data-testid="role-klant-btn"
        className={`flex items-center gap-2 px-5 py-2 rounded-full text-sm font-semibold transition ${
          isClient ? 'bg-[#3da5a5] text-white shadow' : 'text-white/70 hover:text-white'
        }`}
      >
        <User className="w-4 h-4" />
        Klant
      </Link>
    </div>
  );
};

export default LoginRoleToggle;
